import React from "react";
import { styled } from "@mui/system";
import {
  BORDER_PRIMARY,
  BORDER_SECONDARY,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_ALIGN_END,
  FLEX_ALIGN_START,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_SIZE_LG,
  FONT_SIZE_MD,
  FONT_SIZE_SM,
  FONT_WEIGHT_BOLD,
  MAX_WIDTH,
  OVERFLOW_HIDDEN,
  TEXT_ALIGN_LEFT,
  TEXT_DECORATION_NONE,
  WHITE_SPACE_NOWRAP,
} from "../../config/styles";
import { colors } from "../../config/colors";

export const UserManagementStyled = styled("div")(({ theme }) => ({
  "& .page-header": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 40px",
    marginLeft: "256px",
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: "12px 0px",
  },
  "& .table-footer-container": {
    width: MAX_WIDTH,
    marginTop: "75px",
    padding: "16px 0px",
  },
  " &.merchant-name-styled": {
    ...theme.typography.subtitle2,
    lineHeight: "22px",
    whiteSpace: WHITE_SPACE_NOWRAP,
    overflow: OVERFLOW_HIDDEN,
    textOverflow: "ellipsis",
    textDecoration: TEXT_DECORATION_NONE,
  },
  "& .ag-header": {
    backgroundColor: theme.palette.background.default,
    borderBottom: BORDER_SECONDARY,
    ...theme.typography.h4,
    fontWeight: FONT_WEIGHT_BOLD,
  },
  "& .ag-header-cell": {
     backgroundColor: theme.palette.background.default,
    borderRight: "none",
  },
  "& .ag-row": {
    borderBottom: BORDER_SECONDARY,
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .ag-cell-value": {
    ...theme.typography.subtitle2,
    textAlign: TEXT_ALIGN_LEFT,
    paddingTop: "14px",
    paddingBottom: "14px",
  },
  "& .ag-column-first": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },

  "& .migrate-page-body": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    padding: "1.5rem",
    gap: "1.5rem",
    justifyContent: FLEX_ALIGN_END,
    alignItems: FLEX_ALIGN_START,
    borderRadius: ".5rem",
    border: BORDER_SECONDARY,
    width: "520px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .migrate-page-input-style": {
    width: "412px !important",
    display: DISPLAY_FLEX,
    borderRadius: "4px",
    border: BORDER_PRIMARY,
    backgroundColor: theme.palette.secondary.contrastText,
    height: "52px !important",
  },
  "& .migrate-search-button": {
    display: DISPLAY_FLEX,
    height: "52px",
    width: "52px",
    backgroundColor: theme.palette.secondary.contrastText,
    color: theme.palette.background.secondary,
    border: BORDER_PRIMARY,
    marginLeft: "12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  "& .migrate-button-style": {
    display: DISPLAY_FLEX,
    width: MAX_WIDTH,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    gap: ".5rem",
    alignSelf: "stretch",
    borderRadius: "4px",
    backgroundColor: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.contrastText,
    },
    "&:disabled": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.text.disabled,
      cursor: "not-allowed",
      border: "none",
    },
  },

  "& .migrate-seached-title": {
    width: "472px !important",
    color: theme.palette.primary.input,
    fontSize: FONT_SIZE_LG,
    fontWeight: FONT_WEIGHT_BOLD,
    fontFamily: "Open Sans, sans-serif",
    lineHeight: "20px",
  },

  "& .migrate-details-item": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    flex: "33.33%",
  },
  "& .migrate-details-header": {
    fontSize: FONT_SIZE_SM,
    opacity: 0.5,
    fontFamily: "Open Sans, sans-serif",
    color: colors.nonActive,
  },
  "& .migrate-details-body": {
    fontSize: FONT_SIZE_MD,
    opacity: 1,
    fontFamily: "Open Sans, sans-serif",
    color: theme.palette.primary.input,
  },
}));
